import React, {PureComponent} from 'react';

class PastEventStatus extends PureComponent {
    render() {
        const {translation, defaultTranslation} = this.props;
        return (
            <div className="status-button past-button">
                <span>
                    {translation?.auditorium.pastEvent ||
                    defaultTranslation?.auditorium.pastEvent}
                </span>
            </div>
        );
    }
}

export default PastEventStatus;